import { useState } from "react";

import * as Api from "@/api";
import GoTo from "@/app/shared/GoTo";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viCircleDashed, viSpinnerThird, viTrashCan } from "@sippy-platform/valkyrie";

import { IconButton, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function RuleButton({ timetable, rule, timetableDispatch, setActiveRule, activeRule, getGoTo }) {
  const [processing, setProcessing] = useState(false);

  function deleteOption() {
    setProcessing(true);

    Promise.resolve(Api.deleteTimetableRule(timetable, rule))
      .then(() => {
        timetableDispatch({ type: "deleteRule", rule });

        if (activeRule?.id === rule.id) {
          setActiveRule(null);
        }
      })
      .finally(() => setProcessing(false));
  }
  const goTo = getGoTo(rule.overflow);

  return (
    <ListItem
      disablePadding
      secondaryAction={
        rule.id && (
          <IconButton onClick={deleteOption}>
            <Valkyrie icon={processing ? viSpinnerThird : viTrashCan} spin={processing} />
          </IconButton>
        )
      }
    >
      <ListItemButton selected={activeRule?.id === rule.id} onClick={() => setActiveRule(rule)}>
        <ListItemAvatar>
          <Avatar text={rule.color} icon={goTo?.icon || viCircleDashed} color={rule.color} />
        </ListItemAvatar>
        <ListItemText primary={<GoTo target={goTo} hideType />} secondary={<GoTo target={goTo} type />} />
      </ListItemButton>
    </ListItem>
  );
}

RuleButton.propTypes = {
  timetable: PropTypes.object,
  rule: PropTypes.object,
  setActiveRule: PropTypes.func,
  activeRule: PropTypes.object,
  timetableDispatch: PropTypes.func,
  getGoTo: PropTypes.func,
};

export default RuleButton;
